<template>
  <DrField :for="$attrs.id" :label="$attrs['data-label']" :error="error" :formShake="formShake">
    <span class="relative flex">
      <input ref="input" v-bind="$attrs" :class="inputClasses" :value="value" v-on="listeners" />
      <DrIcon v-if="icon" :svg="icon" class="right-center" :class="iconClasses" />
      <div v-if="$slots['input-right']" class="right-center flex">
        <slot name="input-right"/>
      </div>
    </span>
    <div v-if="$slots.help" class="help">
      <slot name="help"/>
    </div>
  </DrField>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    /** @ignore */
    value: {
      type: [String, Number],
      default: '',
    },
    /**
    * Error message for input
    */
    error: {
      type: String,
      default: '',
    },
    /**
    * Form shake
    */
    formShake: {
      type: Boolean,
      default: false,
    },
    /**
    * Icon to display on right of input
    */
    icon: {
      type: String,
      default: '',
    },
    iconColor: {
      type: String,
      default: 'grey-550',
    },
  },
  computed: {
    listeners () {
      return {
        ...this.$listeners,
        input: (event) => this.$emit('input', event.target.value),
      }
    },
    inputClasses () {
      let classes = ''
      if (this.$attrs.inputClass) classes += this.$attrs.inputClass
      if (this.icon) classes += 'pr-8'
      return classes
    },
    iconClasses () {
      return this.error
        ? 'text-red-500'
        : `text-${this.iconColor}`
    }
  },
}
</script>

<style scoped>
.right-center {
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  @apply absolute;
}
</style>

<docs>
This is a transparent component of `<input>`

```vue
<DrInput placeholder="Your name" data-label="Name" />
```

### Errors are handled via props
```vue
<DrInput data-label="Name" error="This is required" />
```

### Input with icon
```vue
<DrInput id="name" icon="checkmark-solid" data-label="Name" />
```
</docs>
